/* Publish by EComposer at 2025-08-05 21:36:58*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a86z38tl4yg"]=  window.__ectimmers["ecom-a86z38tl4yg"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-a86z38tl4yg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a86z38tl4yg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3clzt2chw9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3clzt2chw9a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x00qn1g9wq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x00qn1g9wq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3i1zb2l7wb4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3i1zb2l7wb4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0hi5yi1prnlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0hi5yi1prnlr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uruj8afqk3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uruj8afqk3a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4p1rcbvl3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4p1rcbvl3e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vzn2kpf3n4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vzn2kpf3n4h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcvrq6vock').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcvrq6vock', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-57mlyey7dhu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-57mlyey7dhu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ggu3t0ujbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ggu3t0ujbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9fdr5e1brja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9fdr5e1brja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s1lfpcc7byo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s1lfpcc7byo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-maz5q4adh2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-maz5q4adh2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-syyg3my3ci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-syyg3my3ci', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4m7d1drz9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4m7d1drz9p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vrgrvhakmj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vrgrvhakmj', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rwom73l0k7o"]=  window.__ectimmers["ecom-rwom73l0k7o"] || {};
let e=this.$el;if(!e)return;let i=e.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),t=e.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),o=this.settings.action;i.forEach((a,r)=>{o==="click"||window.screen.width<1025?a.onclick=function(){this.classList&&this.classList.contains("ecom-item-active")||(i.forEach(l=>l.classList.remove("ecom-item-active")),t.forEach(l=>l.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),s()}:a.onmouseover=function(){this.classList&&this.classList.contains("ecom-item-active")||(i.forEach(l=>l.classList.remove("ecom-item-active")),t.forEach(l=>l.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),s()}});function n(){let a=window.location.hash;if(a){let r=e.querySelector(`[data-target="${a}"]`);if(r){r.click();let l=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});r.dispatchEvent(l);let m=r.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{n()},300);function s(){window.dispatchEvent(new window.Event("resize")),setTimeout(()=>{window.dispatchEvent(new window.Event("resize"))},500)}window.addEventListener("hashchange",n,!1)

                    });
                    
                        document.querySelectorAll('.ecom-rwom73l0k7o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwom73l0k7o', settings: {"action":"hover"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lr60u2a090b"]=  window.__ectimmers["ecom-lr60u2a090b"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-lr60u2a090b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lr60u2a090b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwzg1j49d8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwzg1j49d8n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7q5f4b1sa9n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7q5f4b1sa9n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z2bkivzdkbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z2bkivzdkbj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7lsx3tu3zar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7lsx3tu3zar', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cm9h3suu5mr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cm9h3suu5mr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zv2y6xxct6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zv2y6xxct6d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3yjleez52pn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3yjleez52pn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cts30mq6xs7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cts30mq6xs7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6cmo71cdzft').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6cmo71cdzft', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cgl6ti3cuyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cgl6ti3cuyc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8kjmbamx2ne').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8kjmbamx2ne', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}